import React, { Component } from 'react';
import $ from 'jquery';
import Button from 'components/ui/button/Button';
import PrivacyPolicy from 'pages/privacy-policy/PrivacyPolicy';
import OpenLink from 'components/common/open-link/OpenLink';
import { IS_CORDOVA } from 'constants/constants';
import { politicasDoccuments } from 'constants/doccuments/constants';
import { Utils } from 'utils/UtilsDefault';

export default class ModalComplete extends Component {

  closeModal = (): void => {
    $('#ModalCompletePolitica').modal('hide');
  };

  componentWillUnmount = (): void => {
    $('#ModalCompletePolitica').modal('hide');
  };

  render = (): JSX.Element => {
    const doccuments =
      IS_CORDOVA || Utils.isMobileDevice()
        ? politicasDoccuments['mobile']
        : politicasDoccuments['desktop'];

    return (
      <div
        className="modal fade"
        id="ModalCompletePolitica"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="ModalCenter"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header" style={{ background: "#5a005a" }}>
              <h5 className="modal-title" id="ModalCenter">
                Política de Privacidade
              </h5>
              <Button style={{ background: 'transparent' }} onClick={this.closeModal}>
                <span style={{ color: '#2d2d2d' }}>X</span>
              </Button>
            </div>
            <div className="modal-body" style={{overflowY: 'auto'}}><PrivacyPolicy /></div>
            <div className="modal-footer" style={{ justifyContent: 'flex-start' }}>
              <Button className="btn-orange">
                <OpenLink
                  to={doccuments.privacidade}
                  target="_blank"
                >
                  <p style={{ color: "#000000" }}>Política de Privacidade</p>
                </OpenLink>
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  };
}
